var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 2C3.098 2 2.5 2.598 2.5 3.33333V12.6667C2.5 13.402 3.098 14 3.83333 14H13.1667C13.902 14 14.5 13.402 14.5 12.6667V3.33333C14.5 2.598 13.902 2 13.1667 2H3.83333ZM3.83333 3.33333H13.1667L13.168 12.6667H3.83333V3.33333ZM7.83333 4.66667V6H9.16667V4.66667H7.83333ZM7.83333 7.33333V11.3333H9.16667V7.33333H7.83333Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.429773c91f3338fbce62940491d864ed.svg";
export { ForwardRef as ReactComponent };